<app-header #header></app-header>
<div class="container-fluid">
    <div class="row flex-nowrap">
        @if (
        {
        user: authService.user$ | async,
        isAdmin: authService.isAdmin$ | async,
        isUserAdmin: authService.isUserAdmin$ | async,
        isSuperAdmin: authService.isSuperAdmin$ | async
        };
        as authData
        ) {
        @if (authData.user) {
        <div class="col-12 col-md-3 col-xl-2 px-sm-2 px-0 bg-dark collapse"
            [ngbCollapse]="header.menuCollapsed && !isXl" [horizontal]="true">
            <div class="d-flex flex-column flex-shrink-0 py-3 text-white bg-dark c-nav">
                <ul class="nav nav-pills flex-column mb-auto">
                    @if (authData.isUserAdmin) {
                    <li class="nav-item">
                        <a class="nav-link" [routerLink]="['/users']" routerLinkActive="active">
                            <lib-icon name="people-fill" class="me-2"></lib-icon>
                            Users
                        </a>
                    </li>
                    }
                    @if (authData.isSuperAdmin) {
                    <li class="nav-item">
                        <a class="nav-link" [routerLink]="['/roadmaps']" routerLinkActive="active">
                            <lib-icon name="building-fill" class="me-2"></lib-icon>
                            Roadmaps
                        </a>
                    </li>
                    }
                    @if (authData.isUserAdmin) {
                    <li class="nav-item">
                        <a class="nav-link" [routerLink]="['/report']" routerLinkActive="active">
                            <lib-icon name="file-earmark-text-fill" class="me-2"></lib-icon>
                            Report
                        </a>
                    </li>
                    }
                    @if (authData.isSuperAdmin) {
                    <li class="nav-item">
                        <a class="nav-link" [routerLink]="['/email-domains']" routerLinkActive="active">
                            <lib-icon name="envelope-fill" class="me-2"></lib-icon>
                            Email Domains
                        </a>
                    </li>
                    }
                </ul>
            </div>
        </div>
        }
        }

        <div class="col overflow-auto">
            <ng-content></ng-content>
        </div>
    </div>
</div>